import { render, staticRenderFns } from "./SectionNode.vue?vue&type=template&id=f81164b2&scoped=true&"
import script from "./SectionNode.vue?vue&type=script&lang=js&"
export * from "./SectionNode.vue?vue&type=script&lang=js&"
import style0 from "./SectionNode.vue?vue&type=style&index=0&id=f81164b2&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f81164b2",
  null
  
)

export default component.exports